var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticleCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8794 8.875V4.6C12.8794 3.33988 12.8794 2.70982 12.6342 2.22852C12.4184 1.80516 12.0742 1.46095 11.6509 1.24524C11.1696 1 10.5395 1 9.27939 1H4.47939C3.21928 1 2.58922 1 2.10792 1.24524C1.68455 1.46095 1.34034 1.80516 1.12463 2.22852C0.879395 2.70982 0.879395 3.33988 0.879395 4.6V12.4C0.879395 13.6601 0.879395 14.2902 1.12463 14.7715C1.34034 15.1948 1.68455 15.539 2.10792 15.7548C2.58922 16 3.21928 16 4.47939 16H6.87939M8.37939 7.75H3.87939M5.37939 10.75H3.87939M9.87939 4.75H3.87939M8.75439 13.75L10.2544 15.25L13.6294 11.875",
    stroke: "#0D3355",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleCheck);
export default __webpack_public_path__ + "static/media/article-check.ad8c4fe9.svg";
export { ForwardRef as ReactComponent };